import React, { useRef, useState, useEffect } from 'react';
import { css } from '@emotion/react';
import { Photos } from '@frontend/photos';
import { theme } from '@frontend/theme';
import { Text, styles as dsStyles, useTooltip } from '@frontend/design-system';

type OfficeUserNameProps = {
  disableClick?: boolean;
  displayName: string;
  maxWidth?: number;
  showAvatar?: boolean;
  profileName?: string;
  userId?: string;
};

export const OfficeUserName: React.FC<OfficeUserNameProps> = ({
  disableClick = true,
  profileName,
  displayName,
  maxWidth = 200,
  showAvatar = true,
  userId,
}) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const { Tooltip, triggerProps, tooltipProps } = useTooltip({ placement: 'top' });
  const [isOverflown, setIsOverflown] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsOverflown(el.scrollWidth > el.clientWidth);
    }
  }, [displayName, maxWidth]);

  return (
    <div css={styles.wrapper}>
      {showAvatar && (
        <Photos.ContactProfilePhoto
          personId={userId ?? ''}
          name={profileName}
          disableClick={disableClick}
          size='small'
          isUser
        />
      )}
      <span {...(isOverflown ? triggerProps : {})} css={styles.nameWrapper(maxWidth)}>
        <Text ref={textRef} size='medium' css={[dsStyles.truncate]}>
          {displayName}
        </Text>
      </span>
      {isOverflown && (
        <Tooltip {...tooltipProps}>
          <Text size='medium' color='white'>
            {displayName}
          </Text>
        </Tooltip>
      )}
    </div>
  );
};

const styles = {
  wrapper: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
  `,
  nameWrapper: (maxWidth: number) =>
    css({
      maxWidth,
    }),
};
